/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_LabelInputs */

const en_home_unlock_label = /** @type {(inputs: Home_Unlock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Portal Access`)
};

const fr_home_unlock_label = /** @type {(inputs: Home_Unlock_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre accès au portail`)
};

/**
* | output |
* | --- |
* | "Your Portal Access" |
*
* @param {Home_Unlock_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_label = /** @type {((inputs?: Home_Unlock_LabelInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_LabelInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_label(inputs)
	return fr_home_unlock_label(inputs)
});